import CarModernSliderContainer from "../../../components/car/detail/CarModernSlider";

const CarModernSlider = () => {
  return <CarModernSliderContainer />;
};

export default CarModernSlider;
